export default __webpack_public_path__ + "static/media/global-practice-logo.0830d11e.png";